import firebase from 'firebase/app';

export default class TripSourceDetail {}

TripSourceDetail.fetch = async source => {
  const snapshot = await firebase.firestore().collection('trip-source-details').where('source', '==', source).get();
  if (snapshot.docs.length === 0) return null;
  return snapshot.docs[0].data();
};
